import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";
import {DataService} from "../shared/data.service";
import {ApiEndpoints} from "../shared/ApiEndpoints";
import {EMPTY, of} from "rxjs";

@Injectable()
export class NetworkService extends DataService{

  getItems() {
    return this.getRequest(ApiEndpoints.companynetwork);
  }

  getCompanyData(id) {
    return this.getRequest(`${ApiEndpoints.companyChild}/${id}`)
  }

  getDeviceDialogData() {
    return this.getRequest(ApiEndpoints.devicedialog)
  }

  saveNode(data) {
    if (!data) {
      return EMPTY
    }

    delete data.children;

    return this.postRequest(ApiEndpoints.node, data);
  }

  deleteNode(id) {
    if (!id) {
      return of({error: 'Missing ID from delete request'})
    }
    return this.deleteRequest(ApiEndpoints.node, id);
  }
}
